import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=4eac8e60&scoped=true"
import script from "./GroupSetting.vue?vue&type=script&lang=js"
export * from "./GroupSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac8e60",
  null
  
)

export default component.exports